function findGroupPathToUser(group, userId) {
  var _a;
  if (!group) {
    return [];
  }
  if ((_a = group.userDtoList) == null ? void 0 : _a.some((user) => user.id === userId)) {
    return [group];
  }
  for (const subGroup of group.subGroupList ?? []) {
    const subPath = findGroupPathToUser(subGroup, userId);
    if (subPath.length) {
      return [group, ...subPath];
    }
  }
  return [];
}
function getOrgCrumbList(root, userId) {
  const groupList = findGroupPathToUser(root, userId);
  const trailList = groupList.length > 1 ? groupList.slice(1) : groupList;
  return trailList.map((group) => ({
    id: group.id,
    name: group.name,
    groupPath: group.groupPath
  }));
}
export {
  findGroupPathToUser,
  getOrgCrumbList
};
